@if (isSelected()) {
  <div>
    @if (depositOptionValue !== undefined) {
      <p
        class="p2 m-b-2">
        {{'Deposit %' | translate}}
      </p>
    }
    <input-wrap class="w-12 m-b"
      [messages]="{required: 'Please select deposit'}">
    <select class="input"
      name="v12_deposit_value"
      [muiInput]="('Deposit %'| translate)"
      [(ngModel)]="depositOptionValue"
      required>
      <option value=""
        selected
      disabled>{{'Deposit %' | translate}}</option>
      @for (depositOption of depositOptions; track trackByDepositValue($index, depositOption)) {
        <option
        [value]="depositOption.value">{{depositOption.title}}</option>
      }
    </select>
  </input-wrap>
  @if (packOptionId !== undefined) {
    <p
      class="p2 m-b-2">
      {{'Package Plan' | translate}}
    </p>
  }
  <input-wrap class="w-12 m-b"
    [messages]="{required: 'Please select package plan'}">
  <select class="input"
    name="v12_package_plan"
    [muiInput]="('Package Plan'| translate)"
    [(ngModel)]="packOptionId"
    required>
    <option value=""
      selected
    disabled>{{'Package Plan' | translate}}</option>
    @for (packOption of packOptions; track trackByPackId($index, packOption)) {
      <option
      [value]="packOption.id">{{packOption.title}}</option>
    }
  </select>
</input-wrap>
@if (info) {
  <ul class="block m-b"
    >
    @for (item of infoItems; track trackByInfoItemTitleValue(index, item); let even = $even; let index = $index) {
      <li class="flex flex-justify-between p-a-2"
        [class.bg-col-5]="even"
        >
        <span class="s2 no-wrap">
          {{item.title}}
        </span>
        @if (!item.isPrice) {
          <span class="p2 right"
            [ngClass]="{'w-7-s' : index === 0}"
            >
            {{item.value}}
          </span>
        }
        @if (item.isPrice) {
          <price class="p2 right"
            [value]="asNumber(item.value)"
          [precision]="2"></price>
        }
      </li>
    }
  </ul>
}
<v12-retail-finance-info></v12-retail-finance-info>
</div>
}